import ApolloClient from 'apollo-boost';
import { Auth } from 'aws-amplify';

const baseURL =
  import.meta.env.VITE_APP_SSO_API_BASE_URL || 'https://api.iit.myqsrsoft.com';

const wfmUri =
  import.meta.env.VITE_APP_HR_APPSYNC_URI ??
  'https://api.wfm.myqsrsoft.com/graphql';
const fileManagerUri = import.meta.env.VITE_APP_FILE_MANAGER_API_BASE_URL;

export async function getToken() {
  const currentSession = await Auth.currentSession();
  const { idToken } = currentSession;
  return idToken.jwtToken;
}

export async function baseGet(url) {
  const token = await getToken();
  const response = await fetch(`${baseURL}/${url}`, {
    headers: {
      'x-auth-token': token,
    },
  });
  return response.json();
}

export async function basePost(url, body) {
  const token = await getToken();
  const response = await fetch(`${baseURL}/${url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': token,
    },
    body: JSON.stringify(body),
  });
  return response.json();
}

export async function basePut(url, body) {
  const token = await getToken();
  const response = await fetch(`${baseURL}/${url}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': token,
    },
    body: JSON.stringify(body),
  });
  return response.json();
}

export async function baseDelete(url) {
  const token = await getToken();
  const response = await fetch(`${baseURL}/${url}`, {
    method: 'DELETE',
    headers: {
      'x-auth-token': token,
    },
  });
  return response.json();
}

export const alertsApolloClient = new ApolloClient({
  uri: `${baseURL}/alerts/graphql`,
  request: async (operation) => {
    const token = await getToken();
    operation.setContext({
      headers: {
        authorization: token,
      },
    });
  },
});

export const appSyncApolloClient = new ApolloClient({
  uri: import.meta.env.VITE_APP_APPSYNC_URI,
  request: async (operation) => {
    const token = await getToken();
    operation.setContext({
      headers: {
        authorization: token,
      },
    });
  },
});

export const universalApolloClient = new ApolloClient({
  uri: import.meta.env.VITE_APP_API_UNIVERSAL_URI,
  request: async (operation) => {
    const token = await getToken();
    operation.setContext({
      headers: {
        authorization: token,
      },
    });
  },
});

export const wfmApolloClient = new ApolloClient({
  uri: wfmUri,
  request: async (operation) => {
    const token = await getToken();
    operation.setContext({
      headers: {
        authorization: token,
      },
    });
  },
});

export const fileManagerApolloClient = new ApolloClient({
  uri: fileManagerUri,
  request: async (operation) => {
    const token = await getToken();
    operation.setContext({
      headers: {
        authorization: token,
      },
    });
  },
});

const appRunnerAccountsURL = import.meta.env
  .VITE_APP_ACCOUNTS_APP_RUNNER_BASE_URL;
export async function accountsGet(url) {
  const token = await getToken();
  const response = await fetch(`${appRunnerAccountsURL}/${url}`, {
    headers: {
      'x-auth-token': token,
      'content-type': 'application/json',
    },
  });
  return response.json();
}

export async function accountsPost(url, body) {
  const token = await getToken();
  const response = await fetch(`${appRunnerAccountsURL}/${url}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': token,
    },
    body: JSON.stringify(body),
  });
  return response.json();
}

export async function accountsPut(url, body) {
  const token = await getToken();
  const response = await fetch(`${appRunnerAccountsURL}/${url}`, {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      'x-auth-token': token,
    },
    body: JSON.stringify(body),
  });
  return response.json();
}

export async function accountsDelete(url) {
  const token = await getToken();
  const response = await fetch(`${appRunnerAccountsURL}/${url}`, {
    method: 'DELETE',
    headers: {
      'x-auth-token': token,
    },
  });
  return response.json();
}
